<template>
  <div>
    <sub-head class="mobile"></sub-head>
    <div class="page_padding">
      <bread-crumb :path="$route"></bread-crumb>
    </div>
    <div class="title marginT marginB">
      <span class="fontBold font41">스토리 웹툰</span>
    </div>
    <div class="webtoon-wrapper page_padding marginT">
      <img src="@/assets/source/images/webtoon.jpg" alt="스토리 웹툰" />
    </div>
  </div>
</template>

<script>
import SubHead from "@/components/sub_head.vue";
import BreadCrumb from "../../components/BreadCrumb.vue";

export default {
  components: {
    SubHead,
    BreadCrumb,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.background-page {
  background-color: #f2f4f6;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  /* height: 480px; */
  /* height: 28vw; */
}
.d-flex-reverse {
  display: flex;
  flex-direction: row-reverse;
}
.cognitive {
  padding-bottom: 3rem;
}
.cognitive .info-block {
  padding: 2rem;
  box-shadow: 0px 3px 6px #5e331529;
  margin-bottom: 3rem;
  background-color: #ffff;
}
.cognitive-content-wrapper {
  padding: 1rem 2rem;
}
.cognitive-img-container {
  display: flex;
  justify-content: space-between;
}
.cognitive-img-wrapper {
  width: 48%;
}
.cognitive-item-wrapper {
  padding: 5rem 0;
  background-image: url("../../assets/source/images/cognitive_bg.jpg");
  background-repeat: no-repeat;
}

.cognitive-item-flex {
  display: flex;
  justify-content: center;
}
.cognitive-item {
  width: 25%;
}
.icon-wrapper {
  width: 30%;
  margin: 0 auto;
  background-color: white;
  border-radius: 50%;
  padding: 2rem;
}
.content-wrapper {
  padding: 1rem 1rem 2rem 1rem;
}
.content-header {
  margin-bottom: 1rem;
}
.cognitive-info-wrapper {
  background-color: #e7e7e7;
  padding: 1rem 0;
}
.cognitive-info-wrapper .content {
  color: #dc375d;
}
.marginT.marginB {
  margin-bottom: 90px;
}
</style>
